// removed by extract-text-webpack-plugin
module.exports = {"widget":"_2wKuf2xyp25aiqs-DD478S","title":"_3gPx2p2N3BUBSk6OvNmqhm","content":"_1m3KxasRdY4aUuSfJtf7TU","chart":"_1bWmkFevk9YLLyCEyMomf8"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/BoxTimingChart/widget.scss
// module id = 1266
// module chunks = 0